export default __webpack_public_path__ + "assets/images/729b7877536db98d21ec77223e73905a.png";